import instance from "./index";

const normalizeId = (value) => {
  if (value === undefined || value === null || value === "") return null;

  const id = Number(value);
  return Number.isFinite(id) ? id : null;
};

const normalizeProjectRole = (role) => ({
  ...role,
  roleId:
    role?.roleId ??
    role?.RoleId ??
    role?.projectRolesId ??
    role?.ProjectRolesId ??
    role?.projectRoleId ??
    role?.ProjectRoleId ??
    role?.id ??
    role?.Id ??
    null,
  roleName: role?.roleName ?? role?.RoleName ?? role?.name ?? "",
  level: role?.level ?? role?.Level ?? null,
  projectId:
    role?.projectId ??
    role?.ProjectId ??
    role?.project_id ??
    role?.project?.projectId ??
    role?.project?.ProjectId ??
    null,
  projectName:
    role?.projectName ??
    role?.Project_Name ??
    role?.project?.projectName ??
    role?.project?.Project_Name ??
    role?.project?.name ??
    "",
  isDefault: Boolean(
    role?.isDefault ??
      role?.IsDefault ??
      role?.default ??
      role?.Default ??
      false,
  ),
  displayTrue: Boolean(role?.displayTrue ?? role?.DisplayTrue ?? false),
});

export const getAllProjectRoles = async () => {
  try {
    const response = await instance.get("/projectRole/getAll");
    const data = response?.data;
    const list = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : [];

    return list.map(normalizeProjectRole);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load project roles";
    throw new Error(message);
  }
};

export const getProjectRoleById = async (roleId) => {
  if (roleId === undefined || roleId === null || roleId === "") {
    throw new Error("Role id is required");
  }

  try {
    const response = await instance.get(`/projectRole/getById/${roleId}`);
    const data = response?.data?.data ?? response?.data;
    return normalizeProjectRole(data);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load project role";
    throw new Error(message);
  }
};

export const updateProjectRole = async ({ roleId, roleName, level = 1 }) => {
  const trimmedName = String(roleName ?? "").trim();

  if (roleId === undefined || roleId === null || roleId === "") {
    throw new Error("Role id is required");
  }

  if (!trimmedName) {
    throw new Error("Role name is required");
  }

  try {
    const response = await instance.put(
      `/projectRole/updateProjectRoles/${roleId}`,
      {
        roleName: trimmedName,
        level,
      },
    );
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to update project role";
    throw new Error(message);
  }
};

export const createProjectRole = async ({
  roleName,
  level = 1,
  projectId,
  isDefault = false,
}) => {
  const trimmedName = String(roleName ?? "").trim();
  const normalizedProjectId = normalizeId(projectId);

  if (!trimmedName) {
    throw new Error("Role name is required");
  }

  if (!Number.isFinite(normalizedProjectId)) {
    throw new Error("Project is required");
  }

  try {
    const response = await instance.post("/projectRole", {
      roleName: trimmedName,
      level,
      projectId: normalizedProjectId,
      isDefault: Boolean(isDefault),
    });
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to create project role";
    throw new Error(message);
  }
};
